module.exports = __webpack_public_path__ + "common/icon-select-arrow-color-key-a7595930df2f7e1f7772c3c761539595.svg";